export default "__VITE_ASSET__fccb2233__"